export const c_brand_Height = {
  "name": "--pf-v6-c-brand--Height",
  "value": "auto",
  "var": "var(--pf-v6-c-brand--Height)"
};
export default c_brand_Height;